/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
export enum IconName {
  alertCircle = 'alertCircle',
  alertOctagon = 'alertOctagon',
  alertTriangle = 'alertTriangle',
  alertTriangle2 = 'alertTriangle2',
  alertTriangle3 = 'alertTriangle3',
  bath = 'bath',
  bed = 'bed',
  bell = 'bell',
  bucketClean = 'bucketClean',
  cabinet = 'cabinet',
  calendar = 'calendar',
  calendarCheck = 'calendarCheck',
  calendarClean = 'calendarClean',
  camera = 'camera',
  check = 'check',
  checkCircle = 'checkCircle',
  checkCircle2 = 'checkCircle2',
  checkSquare = 'checkSquare',
  chevronLeft = 'chevronLeft',
  chevronRight = 'chevronRight',
  clock = 'clock',
  cloud = 'cloud',
  cloudOff = 'cloudOff',
  cooking = 'cooking',
  copy = 'copy',
  couch = 'couch',
  crown = 'crown',
  dayStatusCoveredIndicator = 'dayStatusCoveredIndicator',
  dayStatusMultipleIndicator = 'dayStatusMultipleIndicator',
  dayStatusOncallIndicator = 'dayStatusOncallIndicator',
  dayStatusRequestedIndicator = 'dayStatusRequestedIndicator',
  doorClose = 'doorClose',
  edit = 'edit',
  externalLink = 'externalLink',
  eye = 'eye',
  fridge = 'fridge',
  garage = 'garage',
  gear = 'gear',
  grill = 'grill',
  headset = 'headset',
  home = 'home',
  homeLineGraph = 'homeLineGraph',
  homePast = 'homePast',
  hotTub = 'hotTub',
  info = 'info',
  infoCircle = 'infoCircle',
  infoFilled = 'infoFilled',
  keys = 'keys',
  leftArrow = 'leftArrow',
  linens = 'linens',
  link2 = 'link2',
  linkBroken = 'linkBroken',
  lock = 'lock',
  mail = 'mail',
  maintenance = 'maintenance',
  mapPin = 'mapPin',
  menu = 'menu',
  messageSquare = 'messageSquare',
  midstayClean = 'midstayClean',
  minusCircle = 'minusCircle',
  note = 'note',
  outside = 'outside',
  party = 'party',
  phone = 'phone',
  playIcon = 'playIcon',
  plus = 'plus',
  plusCircle = 'plusCircle',
  refreshCw = 'refreshCw',
  rightArrow = 'rightArrow',
  search = 'search',
  share = 'share',
  share2 = 'share2',
  slash = 'slash',
  sliders = 'sliders',
  sprayBottle = 'sprayBottle',
  star = 'star',
  sun = 'sun',
  tag = 'tag',
  thumbsUp = 'thumbsUp',
  timesCircle = 'timesCircle',
  trash = 'trash',
  user = 'user',
  user2 = 'user2',
  userCircleSwitch = 'userCircleSwitch',
  userCircleSwitchDanger = 'userCircleSwitchDanger',
  userCircleSwitchNormal = 'userCircleSwitchNormal',
  users = 'users',
  vacasa = 'vacasa',
  vacasa2 = 'vacasa2',
  vacasaHold = 'vacasaHold',
  washer = 'washer',
  watch = 'watch',
  wifi = 'wifi',
  x = 'x',
  zap = 'zap',
}
